import React from 'react';

export interface ExperienceProps {}

const Experience: React.FC<ExperienceProps> = (props) => {
    return (
        <div className="site-page-content">
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Leap Media</h1>
                        <h4>Part-time, Remote</h4>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Research & Content QA Associate</h3>
                        <b>
                            <p>October 2024 - Present</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Leap Media is a video production studio making launch films
                    and founder videos for US tech startups, including Y
                    Combinator-backed companies.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Tag and rate startup launch videos for the studio's
                            reference library against a fixed rubric (hook,
                            format, pacing, industry) in Google Sheets, used to
                            brief editors on every project.
                        </p>
                    </li>
                    <li>
                        <p>
                            Check scripts and on-screen captions for factual
                            accuracy, grammar and timing before client delivery,
                            and log each issue in a shared QA tracker.
                        </p>
                    </li>
                    <li>
                        <p>
                            Transcribe founder interviews and raw footage into
                            time-coded transcripts for the editing team.
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Career Break</h1>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Family and Full-time Parenting</h3>
                        <b>
                            <p>2022 - 2026</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block" />
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Independent Study</h1>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Indian Civil Services Examination (UPSC)</h3>
                        <b>
                            <p>2015 - 2021</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Full-time, self-directed preparation for one of the world's
                    most selective public exams (about 1 million applicants for
                    roughly 1,000 posts each year).
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Read, cross-checked and summarised newspapers,
                            government reports and reference books daily across
                            Indian polity, economy, history, geography, society
                            and international affairs.
                        </p>
                    </li>
                    <li>
                        <p>
                            Planned and ran a multi-year study schedule
                            independently, with regular timed essay and
                            answer-writing practice; completed a B.Ed and CTET
                            alongside it.
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
};

export default Experience;
